<template>
  <div></div>
</template>

<script>
import { verifyOTPService } from "@/services/auth.service.js";
import constants from "@/constants.js";

export default {
  data() {
    return {
      constants,
    };
  },
  computed: {
    invitePhrase() {
      return this.$route.params.invitePhrase;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
  },
  methods: {
    verifyUser(email, loginCode, boardId) {
      const payload = {
        boardId,
        email,
        otp: loginCode,
        currentThis: this,
        userSource: "boardInviteAutoLogin",
      };

      verifyOTPService(payload);
    },
    goToLogin() {
      // window.location.href = '/user/dashboard';
    },
  },
  mounted() {
    this.$vs.loading();

    if (!this.invitePhrase) {
      this.$vs.loading.close();

      this.goToLogin();
    } else {
      this.$store
        .dispatch("auth/decryptInvitePhrase", {
          invitePhrase: this.invitePhrase,
        })
        .then((res) => {
          const email = res.data.inviteData.email;
          const loginCode = res.data.inviteData.loginCode;
          const boardId = res.data.inviteData.boardId;
          if (this.isUserLoggedIn && boardId) {
            this.$vs.loading.close();

            window.location.href = `/user/board/${boardId}`;
          } else if (email && loginCode && boardId) {
            this.verifyUser(email, loginCode, boardId);
          } else {
            this.$vs.loading.close();

            this.goToLogin();
          }
        })
        .catch((err) => {
          this.$vs.loading.close();

          // throw err;
          this.goToLogin();
        });
    }
  },
  created() {},
};
</script>
